var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack377({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 2,
    y: 1.5,
    width: 12,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.36,12.4l-.81-2a.42.42,0,0,0-.44-.27l-1.39.14a6.63,6.63,0,0,1,0-4.48l1.39.13a.42.42,0,0,0,.44-.26l.81-2a.42.42,0,0,0-.17-.52l-1.62-1A.41.41,0,0,0,8,2.13,8.3,8.3,0,0,0,8,13.87H8a.41.41,0,0,0,.53.06l1.62-1a.43.43,0,0,0,.17-.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack377);
export default __webpack_public_path__ + "static/media/Symbol_pack_377.b585521973f5c1e075adce978f1e020c.svg";
export { ForwardRef as ReactComponent };